module.exports = __webpack_public_path__ + "img/rank_head.2ef392e0.png";